// extracted by mini-css-extract-plugin
module.exports = {"easeUp":"ProcessStatus_easeUp__fTqo_","ease-up":"ProcessStatus_ease-up__pK97B"};